<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded">
      <v-card class="ret-card">
        <v-card-title>
          <h3 class="headline">{{ $tc('checklists.entity-name', 1) }}</h3>
          <v-spacer></v-spacer>
          <v-btn v-if="editedItem.id" text color="warn" @click="onDestroy(item)">{{ $t('archive') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <form>
            <v-text-field
              v-model="editedItem.name"
              :label="$t('name')"
            ></v-text-field>
            <v-text-field v-model="editedItem.code" :label="$t('code')"></v-text-field>
            <v-btn @click="$router.go(-1)">{{ $t('back') }}</v-btn>
            <v-btn @click="handleSaveClick" color="primary" :disabled="!isUnsaved">{{ $t('save') }}</v-btn>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemHelpers from '../helpers/item-helpers.es6'

export default {
  name: 'checklist',
  mixins: [displayHelpers, itemHelpers],
  data: function () {
    return {
      model: { name: 'checklists' }
    }
  }
}
</script>
